import { render } from "./Calendar.vue?vue&type=template&id=edb7aa86&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=edb7aa86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-edb7aa86"

export default script